export interface CountryLocaleConfig {
  locale: string;
  currency: string;
  timezone: string;
  firstDayOfWeek: 1 | 7; // 1 = Monday (ISO), 7 = Sunday
  measurementSystem: 'metric' | 'imperial';
}

/**
 * Maps ISO 3166-1 alpha-2 country codes to locale/currency/timezone defaults.
 * Indexed access returns `CountryLocaleConfig | undefined` due to noUncheckedIndexedAccess.
 */
export const countryLocaleMap: Record<string, CountryLocaleConfig> = {
  US: {
    locale: 'en-US',
    currency: 'USD',
    timezone: 'America/New_York',
    firstDayOfWeek: 7,
    measurementSystem: 'imperial',
  },
  GB: {
    locale: 'en-GB',
    currency: 'GBP',
    timezone: 'Europe/London',
    firstDayOfWeek: 1,
    measurementSystem: 'metric',
  },
  DE: {
    locale: 'de-DE',
    currency: 'EUR',
    timezone: 'Europe/Berlin',
    firstDayOfWeek: 1,
    measurementSystem: 'metric',
  },
  FR: {
    locale: 'fr-FR',
    currency: 'EUR',
    timezone: 'Europe/Paris',
    firstDayOfWeek: 1,
    measurementSystem: 'metric',
  },
  ES: {
    locale: 'es-ES',
    currency: 'EUR',
    timezone: 'Europe/Madrid',
    firstDayOfWeek: 1,
    measurementSystem: 'metric',
  },
  IN: {
    locale: 'en-IN',
    currency: 'INR',
    timezone: 'Asia/Kolkata',
    firstDayOfWeek: 1,
    measurementSystem: 'metric',
  },
  JP: {
    locale: 'ja-JP',
    currency: 'JPY',
    timezone: 'Asia/Tokyo',
    firstDayOfWeek: 1,
    measurementSystem: 'metric',
  },
  AU: {
    locale: 'en-AU',
    currency: 'AUD',
    timezone: 'Australia/Sydney',
    firstDayOfWeek: 1,
    measurementSystem: 'metric',
  },
  CA: {
    locale: 'en-CA',
    currency: 'CAD',
    timezone: 'America/Toronto',
    firstDayOfWeek: 7,
    measurementSystem: 'metric',
  },
  BR: {
    locale: 'pt-BR',
    currency: 'BRL',
    timezone: 'America/Sao_Paulo',
    firstDayOfWeek: 7,
    measurementSystem: 'metric',
  },
};
